const env = import.meta.env;
const envConfig = {
    env: env.VITE_ENV,
    baseUrl: env.VITE_BASE_URL,
    aMapStyle: env.VITE_AMAP_STYLE
} as const
export { envConfig }